import { render, staticRenderFns } from "./examAreaAddEdit.vue?vue&type=template&id=29529ef0&scoped=true"
import script from "./examAreaAddEdit.vue?vue&type=script&lang=js"
export * from "./examAreaAddEdit.vue?vue&type=script&lang=js"
import style0 from "./examAreaAddEdit.vue?vue&type=style&index=0&id=29529ef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29529ef0",
  null
  
)

export default component.exports